<sl-title title="Payment Card Setup"></sl-title>

<mat-card class="linq-card--legacy stacked">
	<mat-card-content>
		<mat-tab-group dynamicHeight class="linq-tab-bar">
			<mat-tab label="P-Card">
				<purchase-card-setup #purchaseCardSetupComponent [isReadOnly]="isReadOnly"></purchase-card-setup>
			</mat-tab>
			<mat-tab label="Credit Card" *ngIf="creditCardEnabled">
				<credit-card-setup #creditCardSetupComponent [isReadOnly]="isReadOnly"></credit-card-setup>
			</mat-tab>
			<mat-tab label="Virtual Card" *ngIf="virtualCardEnabled">
				<virtual-card-setup #virtualCardSetupComponent [isReadOnly]="isReadOnly"></virtual-card-setup>
			</mat-tab>
		</mat-tab-group>
	</mat-card-content>
</mat-card>